
  import { commonModule } from '@/store/modules/store-accessor'
  import Vue from "vue";
  import { Component, Prop, Watch } from "vue-property-decorator";
  import { assigneeSearchFilter } from "@/helpers/data";
  
  @Component
  export default class AssigneeUserCombo extends Vue {
    selectedAssignee = null as any;
    assigneeItems = [] as any[];

    @Prop() defaultAssignee!: any; // for edit modals & add appointment in the calendar page
    @Prop({ default: true }) rightMargin!: boolean; // will set it to false in the add job modal

    loading = true;
    assigneeSearchFilter = assigneeSearchFilter;

    selectEntry() {
      this.$emit('update-filter', this.selectedAssignee);
    }

    findComboItemForAssignee(assignee: any, combo: any[]) {
      const name = (assignee?.name ?? "").trim();
      const id = assignee?.id;
      if (id != null && id !== "") {
        const byId = combo.find((item: any) => String(item.id) === String(id));
        if (byId) return byId;
      }
      if (name) {
        return combo.find((item: any) => (item.name ?? "").trim() === name);
      }
      return undefined;
    }

    refreshAssigneeItems() {
      const src = commonModule.personnelCombo;
      this.assigneeItems = Array.isArray(src) ? [...src] : [];
    }

    applyFromDefaultAssignee(emitUpdate: boolean) {
      if (!this.defaultAssignee || typeof this.defaultAssignee !== "object") {
        return;
      }
      const row = this.findComboItemForAssignee(this.defaultAssignee, this.assigneeItems);
      if (row) {
        this.selectedAssignee = row;
      } else {
        const extra =
          this.defaultAssignee.id != null && this.defaultAssignee.id !== ""
            ? { name: this.defaultAssignee.name, id: this.defaultAssignee.id }
            : { name: this.defaultAssignee.name };
        this.assigneeItems.push(extra);
        this.selectedAssignee = extra;
      }
      if (emitUpdate) {
        this.$emit("update-filter", this.selectedAssignee);
      }
    }

    async ensurePersonnelLoaded() {
      await commonModule.getPersonnelCombo();
      this.refreshAssigneeItems();
    }

    @Watch("defaultAssignee", { deep: true })
    async onDefaultAssigneeChanged() {
      if (!this.assigneeItems.length) {
        await this.ensurePersonnelLoaded();
      }
      if (this.defaultAssignee && typeof this.defaultAssignee === "object") {
        this.applyFromDefaultAssignee(true);
      }
    }

    async mounted() {
      await this.ensurePersonnelLoaded();
      this.applyFromDefaultAssignee(true);
      this.loading = false;
    }

    rules = [
      (val: any) => !!val || this.$i18n.t("user_required"),
    ]

  }
